"use client";

import { ExecutiveSummarySection } from "@/components/sections/executive-summary";
import { executiveSummary } from "@/lib/data/services-dialogue-control";

export function ExecutiveSummary() {
  return (
    <ExecutiveSummarySection
      primaryAccent={"var(--color-purple)"}
      eyebrow={executiveSummary.eyebrow}
      title={executiveSummary.title}
      intro={executiveSummary.intro}
      paragraphs={executiveSummary.paragraphs}
      metrics={executiveSummary.metrics}
      cta={executiveSummary.cta}
    />
  );
}
